import { domAnimation, LazyMotion, MotionConfig } from "motion/react";
import type { ReactNode } from "react";

/**
 * Motion Provider using LazyMotion for smaller bundle size.
 *
 * Wrap your app or component tree with this provider to use the lightweight
 * `m` component from framer-motion instead of `motion`.
 *
 * `MotionConfig reducedMotion="user"` lives here (inside LazyMotion) so EVERY
 * mount of MotionProvider inherits the OS reduced-motion preference centrally —
 * individual components no longer need their own `useReducedMotion()` gate. This
 * is the single place that honors the Fluid Functionalism motion rule "all
 * springs respect the OS setting".
 *
 * @see https://www.framer.com/motion/guide-reduce-bundle-size/
 */
export function MotionProvider({ children }: { children: ReactNode }) {
	return (
		<LazyMotion features={domAnimation}>
			<MotionConfig reducedMotion="user">{children}</MotionConfig>
		</LazyMotion>
	);
}
